import React from 'react'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';
import slide_1 from './assets/H1.JPG';
import slide_2 from './assets/H6.JPG';
import slide_3 from './assets/H5.JPG';
import slide_4 from './assets/H2.JPG';
import slide_5 from './assets/H3.JPG';
import slide_6 from './assets/H4.JPG';
import logo from './assets/H7.JPG';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default function Carousel() {
    return (
        <Swiper modules={[Navigation, Pagination, Scrollbar, A11y]}
            navigation
            spaceBetween={30}
            loop={true}
            slidesPerView={1}
            onSlideChange={() => console.log('slide change')}
            onSwiper={(swiper) => console.log(swiper)}
        >
            <SwiperSlide><img src={logo} alt="logo" height="450px" width="450px" /></SwiperSlide>
            <SwiperSlide><img src={slide_1} alt="logo" height="450px" width="450px" /></SwiperSlide>
            <SwiperSlide><img src={slide_2} alt="logo" height="450px" width="450px" /></SwiperSlide>
            <SwiperSlide><img src={slide_3} alt="logo" height="450px" width="450px" /></SwiperSlide>
            <SwiperSlide><img src={slide_4} alt="logo" height="450px" width="450px" /></SwiperSlide>
            <SwiperSlide><img src={slide_5} alt="logo" height="450px" width="450px" /></SwiperSlide>
            <SwiperSlide><img src={slide_6} alt="logo" height="450px" width="450px" /></SwiperSlide>

        </Swiper>
    )
}
